import { UseQueryOptions } from '@tanstack/react-query';

import APIError from 'types/api_error';
import { Organization } from 'types/organization';

import { useAPI } from './api/useAPI';
import { useAuthenticatedQuery } from './api/useAuthenticatedQuery';
import { useOrganizations } from './api/useOrganizations';

export function useOrganization(
  organizationId?: string,
  options?: Omit<
    UseQueryOptions<Organization | undefined, APIError>,
    'placeholderData'
  >
) {
  const { client } = useAPI();
  const { data: organizations } = useOrganizations();

  return useAuthenticatedQuery(
    ['organization', organizationId],
    async () => {
      if (!organizationId) {
        return Promise.reject(new Error('No organization ID provided.'));
      }

      const { data } = await client.get<Organization>(
        `/orgs/${organizationId}`
      );
      return data;
    },
    {
      ...options,
      enabled:
        options && options?.enabled !== undefined
          ? Boolean(organizationId) && options.enabled
          : Boolean(organizationId),
      staleTime: options?.staleTime || Infinity,
      placeholderData() {
        return organizations?.find(
          (organization) => organization.id === organizationId
        );
      },
    }
  );
}
